module.exports = __webpack_public_path__ + "img/side-uparrow.ebc519f7.svg";